import { lazy } from "react"

export const GAME_MODALS = {
  mineGameGuide: {
    component: lazy(() => import("modals/ui/mine/mine-guide"))
  },
  mineGameShovelRequired: {
    component: lazy(() => import("modals/ui/mine/mine-shovel-required")),
    params: {} as {
      goToShop: () => void
    }
  },
  speedUpUnavailable: {
    component: lazy(() => import("modals/ui/mine/SpeedUpUnavailable"))
  },
  confirmYourAction: {
    component: lazy(() => import("modals/ui/mine/confirmYourAction")),
    params: {} as {
      onConfirm: () => void
    }
  },
  insufficientBones: {
    component: lazy(() => import("modals/ui/mine/InsufficientBones"))
  },
  diggingCompleted: {
    component: lazy(() => import("modals/ui/mine/DiggingCompleted"))
  },
  leaveMineGame: {
    component: lazy(() => import("modals/ui/mine/mine-leave")),
    params: {} as {
      onLeave: () => void
      onExit: () => void
    }
  },
  mineAccessRestricted: {
    component: lazy(() => import("modals/ui/mine/mine-access-restricted"))
  },
  skipMiningCycle: {
    component: lazy(() => import("modals/ui/mine/SkipMiningCycle"))
  },
  timerTillNextSkip: {
    component: lazy(() => import("modals/ui/mine/TimerTillNextSkip")),
    params: {} as {
      lastSkipDigging: string | undefined
    }
  },
  mineSupporters: {
    component: lazy(() => import("modals/ui/mine/mine-supporters"))
  },
  mineBanned: {
    component: lazy(() => import("modals/ui/mine/mine-banned"))
  }
} as const
